import { render, staticRenderFns } from "./ProzessMetastatusForm.vue?vue&type=template&id=93659dd2"
import script from "./ProzessMetastatusForm.vue?vue&type=script&lang=js"
export * from "./ProzessMetastatusForm.vue?vue&type=script&lang=js"
import style0 from "./ProzessMetastatusForm.vue?vue&type=style&index=0&id=93659dd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports